import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Skeleton,
  Avatar,
} from "@mui/material";

const cardCount = 4;

const AllocationSkeleton: React.FC = () => {
  return (
    <Box >
      <Grid container spacing={2}>
        {Array.from({ length: cardCount }).map((_, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card
              sx={{
                height: 80,
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <CardHeader
                avatar={
                  <Avatar sx={{ bgcolor: "grey.200" }}>
                    <Skeleton variant="circular" width={32} height={32} />
                  </Avatar>
                }
                title={<Skeleton variant="text" width={100} height={24} />}
                subheader={<Skeleton variant="text" width={200} height={18} />}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AllocationSkeleton;
